import { Grid, Typography, Skeleton } from "@mui/material";
import { fieldHeader } from "../../../../../components/fields/field_header";

const SkeletonLoader = () => {
  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h6" color={"white"} bgcolor={"red"} p={0.5}>
          STORE INFORMATION:
        </Typography>
      </Grid>

      {/* Store Name */}
      <Grid item xs={12}>
        <Grid item>{fieldHeader("Store Name", true)}</Grid>
        <Skeleton variant="text" width="100%" height={40} />
      </Grid>

      {/* Store Physical Address */}
      <Grid item xs={12}>
        <Grid item>{fieldHeader("Store Physical Address", true)}</Grid>
        <Skeleton variant="text" width="100%" height={40} />
      </Grid>

      {/* City, State, ZIP - 3 Columns */}
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("Physical City", true)}</Grid>
        <Skeleton variant="text" width="100%" height={40} />
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("Physical State", true)}</Grid>
        <Skeleton variant="text" width="100%" height={40} />
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("Physical ZIP", true)}</Grid>
        <Skeleton variant="text" width="100%" height={40} />
      </Grid>

      {/* Store Billing Address */}
      <Grid item xs={12}>
        <Grid item>{fieldHeader("Store Billing Address", false)}</Grid>
        <Skeleton variant="text" width="100%" height={40} />
      </Grid>

      {/* Billing City, Billing State, Billing ZIP - 3 Columns */}
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("Billing City", false)}</Grid>
        <Skeleton variant="text" width="100%" height={40} />
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("Billing State", false)}</Grid>
        <Skeleton variant="text" width="100%" height={40} />
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("Billing ZIP", false)}</Grid>
        <Skeleton variant="text" width="100%" height={40} />
      </Grid>

      {/* PO Box */}
      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("P.O. Box", false)}</Grid>
        <Skeleton variant="text" width="100%" height={40} />
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("P.O. Box City", false)}</Grid>
        <Skeleton variant="text" width="100%" height={40} />
      </Grid>

      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("P.O. Box State", false)}</Grid>
        <Skeleton variant="text" width="100%" height={40} />
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid item>{fieldHeader("P.O. Box ZIP", false)}</Grid>
        <Skeleton variant="text" width="100%" height={40} />
      </Grid>

      {/* Store Phone, Store Email, Store Website - 3 Columns */}
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("Store Phone", true)}</Grid>
        <Skeleton variant="text" width="100%" height={40} />
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("Store Email", true)}</Grid>
        <Skeleton variant="text" width="100%" height={40} />
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("Store Website", false)}</Grid>
        <Skeleton variant="text" width="100%" height={40} />
      </Grid>

      {/* # Checkouts, # Self Checkouts, POS System - 3 Columns */}
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("# Checkouts", false)}</Grid>
        <Skeleton variant="text" width="100%" height={40} />
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("# Self Checkouts", false)}</Grid>
        <Skeleton variant="text" width="100%" height={40} />
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid item>{fieldHeader("Type of POS System", true)}</Grid>
        <Skeleton variant="text" width="100%" height={40} />
      </Grid>
    </>
  );
};

export default SkeletonLoader;
